import { getPlayerIdFromTypedId } from "../../util/IdUtils";
export function getOwnerId(data) {
    return getPlayerIdFromTypedId(data.id);
}
//# sourceMappingURL=ReplicatedData.js.map